var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',{attrs:{"outlined":"","label":_vm.name,"readonly":_vm.readonly,"disabled":_vm.disabled},model:{value:(_vm.localData),callback:function ($$v) {_vm.localData=$$v},expression:"localData"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }